import React from 'react';
import { useDispatch } from 'react-redux';

import { Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

import { createGetPingAction } from '../../actions/health';

const getPingAction = createGetPingAction();
const year = (new Date()).getFullYear();

const Container = styled('div')({
	flexGrow: 1,
	textAlign: 'center',
});

const useStyles = (theme: any) => ({
    root: {
		padding: theme.spacing(2),
    },
});

export default (props: { name: string }) => {
    const classes = useStyles(useTheme());
	const dispatch = useDispatch();
	
	React.useEffect(() => {
		dispatch(getPingAction());
	}, []);

    return (
        <Container sx={classes.root}>		
			<Typography color='textSecondary'>Copyright © {props.name} {year}</Typography>	
        </Container >
    ); 
}